// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".state-banner[data-v-84e96ca6]{margin-top:1.5rem;width:100%;padding:7px 18px 5px;background-color:#d2d3d5;color:#000;font-size:1.5rem;font-weight:700;text-transform:uppercase;text-align:center}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
